import { useQuery } from "react-query";
import axios from "infra/http";
import { TimelineLog } from "components/TimelineLogs";

function useLogsProtestoConta(id: string | undefined) {
  return useQuery(
    `/v1/conta/${id}/logs-protesto`,
    async () => {
      const { data } = await axios.get<TimelineLog[]>(
        `/v1/conta/${id}/logs-protesto`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useLogsProtestoConta;
